const resource = '/admin/v1/document/categories';

export default $axios => ({
  index() {
    return $axios.get(`${resource}`);
  },

  getTree() {
    return $axios.get(`${resource}/tree`);
  },

  show(id) {
    return $axios.get(`${resource}/${id}`);
  },

  create(payload) {
    return $axios.post(`${resource}`, payload);
  },

  update(id, payload) {
    return $axios.put(`${resource}/${id}`, payload);
  },

  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  }
});
